export const useParticipatesInTreeSetSettleTracking = (
  readOnly?: boolean,
  tracksTreeSetSettlement = true,
): boolean => !readOnly && tracksTreeSetSettlement;
